<template>
    <div>
        <div class="row">
            <div class="col-md-6">
                <div class="card">
                    <div class="card-body">
                        <legend class="text-uppercase font-size-sm font-weight-bold">Options</legend>
                        <div class="row">
                            <div class="col">
                                <basic-input label="Template Id" :vertical="true" :rule="'required minMax:9:9'" v-model="tmplId" :disabled="true"/>
                            </div>
                        </div>
                        <div class="row" v-if="info.msgType === $const.MSG_TYPE.MAIL">
                            <div class="col">
                                <mail-subject-editor @emitChangeModel="onChangeModelSubject" v-model="info" ref="mailSubjectEditor" />
                            </div>
                        </div>
                        <div class="row" v-if="info.msgType === $const.MSG_TYPE.MAIL">
                            <div class="col">
                                <basic-input label="From" :vertical="true" rule="required max:100 email" v-model="info.mailFrom"/>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <select2 :options="msgTypeOptions" v-model="info.msgType" @change="changeMsgType" :vertical="true" :label="'Message Type'" rule="required"/>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <select2 :options="languageOptions" v-model="info.lang" :vertical="true" :label="'Language'" rule="required"/>
                            </div>
                        </div>
                        <div class="row" v-if="info.msgType === $const.MSG_TYPE.MAIL">
                            <div class="col">
                                <select2 :options="layoutsOptions" v-model="info.mailLayoutId" :vertical="true" :label="'Layout'" rule="required"/>
                            </div>
                        </div>
                        <div class="row mb-3" v-if="info.msgType === $const.MSG_TYPE.MAIL">
                            <div class="col-12">
                                <button class="btn btn-ums" style="width: 100%" @click="preview">Preview</button>
                            </div>
                        </div>
                        <div class="row" v-if="info.msgType === $const.MSG_TYPE.SMS">
                            <div class="col">
                                <select2 :options="smsSenderOptions" v-model="info.smsSenderId" :vertical="true" :label="'Sender'" rule="required"/>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-12">
                                <button class="btn btn-ums" style="width: 100%" @click="save" v-if="hasRole($const.ROLES.TEMPLATE_SAVE)">Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="card">
                    <div class="card-body">
                        <legend class="text-uppercase font-size-sm font-weight-bold">Content</legend>
                        <mail-content-editor v-if="info.msgType === $const.MSG_TYPE.MAIL" @emitChangeModel="onChangeModel" v-model="info" ref="mailContentEditor"/>
                        <sms-content-editor v-else-if="info.msgType === $const.MSG_TYPE.SMS" @emitChangeModel="onChangeModel" v-model="info" ref="smsContentEditor"/>
                        <app-content-editor v-else @emitChangeModel="onChangeModel" v-model="info" ref="appContentEditor"/>
                    </div>
                </div>
            </div>
        </div>
        <mail-type-preview-modal :target="modalTarget" ref="mailTypePreviewModal"/>
    </div>
</template>

<script>
    import validation from "@/config/mixin/validation";
    import Select2 from "@/components/form/select/Select2";
    import BasicInput from "@/components/form/input/BasicInput";
    import MailContentEditor from "@/components/editor/MailContentEditor";
    import MailSubjectEditor from "@/components/editor/MailSubjectEditor";
    import SmsContentEditor from "@/components/editor/SmsContentEditor";
    import AppContentEditor from "@/components/editor/AppContentEditor";
    import api from "@/api/template"
    import MailTypePreviewModal from "@/components/modal/MailTypePreviewModal";
    export default {
        name: "TemplateCreate",
        components: {
            MailTypePreviewModal,
            SmsContentEditor,
            MailContentEditor,
            MailSubjectEditor,
            Select2,
            BasicInput,
            AppContentEditor
        },
        mixins:[validation],
        props: {
            queueType: {
                type: String,
                required: false
            },
            messageInfo: {
                type: Object,
                required: true
            },
        },
        data(){
            return {
                info: {
                    tmplId:'',
                    tmplContent:'',
                    clientId:'',
                    msgType: '',
                    lang: '',
                    params:[],
                    paramSubjects:[],
                    mailLayoutId:'',
                    mailFrom:'noreply@support.com',
                    subject:'',
                    smsSenderId:'',
                    addParamSubjYn: '',

                },
                defaultTmplId : '',
                modalData:{},
                layoutName:'',
            }
        },
        watch: {
            'info.msgType': function(newVal) {
                // msgType 값이 다른 타입에서 sms로 변경되면 smsSenderId 없어 직접 초기화 (data의 초기값은 mounted에서 날라감)
                if(newVal === this.$const.MSG_TYPE.SMS && !this.info.smsSenderId) this.info.smsSenderId = ''
            }
        },
        mounted() {
            if(this.messageInfo.msgType) this.info =  $.extend(true,{},this.messageInfo)
            this.defaultTmplId = this.info.tmplId
            this.info.eventId = this.storedEventInfo.eventId
            this.info.paramCnt = this.storedEventInfo.paramCnt
            this.info.paramSubjectCnt = this.storedEventInfo.paramSubjectCnt
            console.log('smsSenderId>>', this.info.smsSenderId)
        },
        computed: {
            modalTarget: function() {
                return 'messageModal-type-'+this.info.msgType + this._uid
            },
            currentEditorNm: function() {
                if(this.info.msgType === this.$const.MSG_TYPE.MAIL) {
                    return 'mailContentEditor'
                } else if(this.info.msgType === this.$const.MSG_TYPE.SMS) {
                    return 'smsContentEditor'
                } else {
                    return 'appContentEditor'
                }
            },
            tmplId: function() {
                return this.eventId + this.info.msgType + this.info.lang
            },
            eventId: function() {
                return this.$route.query.eventId
            },
            languageOptions: function() {
                return this.$store.getters[this.$const.GETTERS.LANGUAGE_OPTIONS]()
            },
            layoutsOptions: function() {
                return this.$store.getters[this.$const.GETTERS.LAYOUT_OPTIONS]()
            },
            msgTypeOptions: function() {
                return this.$store.getters[this.$const.GETTERS.MSG_TYPE_OPTIONS]()
            },
            smsSenderOptions: function () {
                return this.$store.getters[this.$const.GETTERS.SENDER_OPTIONS](this.queueType).map(item => ({text: item.codeNm, value: item.code}))
            },
            storedEventInfo: function() {
                return this.$store.getters[this.$const.GETTERS.STORED_EVENT_INFO]()
            },
        },
        methods: {
            save:function () {
                if(!this.validationCheck()) return;
                this.$refs[this.currentEditorNm].emitData()
                if(this.info.msgType === this.$const.MSG_TYPE.MAIL) {
                    this.$refs["mailSubjectEditor"].emitData()
                }
                this.info.tmplId = this.tmplId
                let flag = this.checkTmplId(this.info)
                flag.then((flag) => {
                    if(flag) {
                        api.saveTemplate(this.info).then((result)=>{
                            if(result && result.data.code === 1000) {
                                this.$notify.success('Saved')
                                this.$emit('templateUpdated')
                                this.$store.dispatch(this.$const.ACTIONS.CALL_EVENT_INFO,{eventId: this.eventId})
                            } else {
                                this.$notify.alert(result.data.message)
                            }
                        })
                    }
                })
            },
            checkTmplId: async function(info) {
                if(this.defaultTmplId !== info.tmplId) {
                    let result = await api.getTemplatesInEvents(info)
                    if(!result) return false
                    if(result && result.data.code === 1000) {
                        let messages = result.data.content.messages
                        let checked = messages.filter(item=> item.tmplId === info.tmplId)
                        if(checked.length > 0) {
                            this.$notify.alert('Template Id is already exists.')
                            return false
                        }
                        return true
                    } else {
                        this.$notify.alert(result.data.message)
                        return false
                    }
                }
                return true
            },
            onChangeModel: function(content,params) {
                this.info.tmplContent = content
                this.info.params = params
            },
            onChangeModelSubject: function(subject,params) {
                this.info.subject = subject
                this.info.paramSubjects = params
            },
            changeMsgType: function() {
                this.$refs[this.currentEditorNm].changeData(this.info)
                if(this.info.msgType === this.$const.MSG_TYPE.MAIL) {
                    this.$refs["mailSubjectEditor"].changeData(this.info)
                }
            },
            preview: function() {
                if(!this.validationCheck()) return;
                this.modalData = this.info
                this.layoutName = this.layoutsOptions.find((el) => {
                    return el.value === this.modalData.mailLayoutId
                }).path
                let previewObj = $.extend(true,{},this.info)
                previewObj.tmplContent = this.getChangedSampleContent()
                this.$refs.mailTypePreviewModal.setData(previewObj,this.layoutName)
                $("#"+ this.modalTarget).modal('toggle')
            },
            getChangedSampleContent: function() {
                let content = this.$refs.mailContentEditor.tmplContent
                let regex = this.$refs.mailContentEditor.regex
                let params = this.$refs.mailContentEditor.params
                console.log(params)
                let keys = content.match(regex)
                if(keys && content.match(regex).length > 0) {
                    content = content.replace(/{{([1-9]{1,1})(\:)([S])}}/g, 'sample string')
                        .replace(/{{([1-9]{1,1})(\:)([A])}}/g, '1,000,000')
                        .replace(/{{([1-9]{1,1})(\:)([T])}}/g, '15:19 30/09/2020')
                        .replace(/{{([1-9]{1,1})(\:)([H])}}/g, '15:19')
                        .replace(/{{([1-9]{1,1})(\:)([D])}}/g, '30/09/2020')
                }
                return content
            }
        },
    }
</script>

<style scoped>
    .flex-display {
        display: flex;
    }
    .color-red {
        color:red;
    }
</style>
